export { renderMenuItemLink_unstable as renderMenuItemLink } from '@fluentui/react-menu';
